module.exports = __webpack_public_path__ + "media/images/admin/icons/credit-card-d54e03874ef5af85ae1758de03816809.svg";